import { getContext } from '@fiverr-private/fiverr_context';
import { Domingo } from '@fiverr-private/domingo';

/**
 * Get absolute URL to the Certified search page by partner slug.
 */
export const getCertifiedPartnerHomeHref = (partner: string) => {
    return Domingo(getContext().url)
        .pro()
        .path(
            'certified_search_page',
            { partner },
            {
                query: {
                    utm_source: 'fiverr_certified',
                    utm_medium: partner,
                    utm_campaign: `${partner}_banner`,
                },
            }
        ).url;
};
